import { call, put } from 'redux-saga/effects';
import UpdateProfilePicActions from '../redux/UpdateProfilePicRedux';
import { api } from './api';

export function* updateprofilepicsagas(action: any): Generator<any, void, any> {
  try {
    const { id, image } = action;  // Fixed: matches new action parameters
    
    if (!id) {
      console.error('No ID provided for profile picture update');
      yield put(UpdateProfilePicActions.updateProfilePicFailure());
      return;
    }
    
    console.log('Updating profile picture for child ID:', id);
    
    // Call API with correct child ID and base64 format
    const response = yield call(api.updateProfilePic, id, image);

    // success?
    if (response.ok) {
      console.log('Profile picture update successful:', response.data);
      yield put(UpdateProfilePicActions.updateProfilePicSuccess(response.data));
    } else {
      console.error('Profile picture update failed:', response);
      yield put(UpdateProfilePicActions.updateProfilePicFailure());
    }
  } catch (error) {
    console.error('Error in profile picture update saga:', error);
    yield put(UpdateProfilePicActions.updateProfilePicFailure());
  }
}